import {post} from '../utils/request'

export default {
    getAll: function (query) {
        return post("/admin/device/list", query || {});
    },
    findById: function (id) {
        return post("/admin/device/show", {id});
    },
    findLast: function () {
        return post("/admin/device/last", {});
    },
    create: function (device) {
        return post("/admin/device/create", device);
    },
    update: function (device) {
        return post("/admin/device/update", device);
    },

    deleteById: function (id) {
        return post("/admin/device/delete", {id});
    },
}
